import { makeObservableRowBase, RowBase } from 'shared/ui/TableNew/model/RowBase'
import { type IResponseTag } from 'entities/Tags'

export class TagsRow extends RowBase<IResponseTag> {
  constructor(origin: IResponseTag) {
    super(origin)
    makeObservableRowBase(this)
  }

  get name() {
    return this.origin.name
  }

  get count() {
    return this.origin.contacts_count
  }
}
